module.exports = __webpack_public_path__ + "static/img/left2.97931540.png";